import { useState, useEffect } from 'react';

import { gql, useQuery } from '@apollo/client';

const query = gql`
  query getEnvironment {
    ggEnvironment
  }
`;

interface Environment {
  ggEnvironment: SensoryLinkEnvironment;
}

/**
 * This is needed because we do not have access to the process API in a web app.
 * So the node way of going process.env.environment will not work for us.
 * Instead we query for the environment of the backend as a proxy to figure out the frontend environment.
 * 
 * Use this hook to fetch the literal environment string.
 * There are a list of functions in environmentUtils.ts that act on this string.
 * 
 * @returns Environment of the GraphQL Interface process.
 */
export default function useGgEnvironment(): SensoryLinkEnvironment {
  const [environment, setEnvironment] = useState<SensoryLinkEnvironment>(null);

  const { data, loading, error } = useQuery<Environment>(query);

  useEffect(() => {
    if (!loading && !error) {
      setEnvironment(data?.ggEnvironment);
    }
  }, [data]);

  return environment;
}
